import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ENDPOINTS } from "../../js/api/_config";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router";
import PrimaryButton from "../common/buttons/PrimaryButton";
import { Link } from "react-router";
import Header from "../common/header/Header";
import PdfExport from "./export-pdf";
import ExcelExport from "./export-excel";
import { customStyles } from "../common/styling/constants";

import { useDispatch, useSelector } from "react-redux";
import { getClinicInformation } from "../../reducer/slices/clinic/get-clinicinfo-slice";
import SecondaryButton from "../common/buttons/SecondaryButton";
import { Toast } from "../common/toast/toast";
import { IconSortyBy } from "../../assets/icons/icon-sortby-arrow";
import { IconExportArrow } from "../../assets/icons/icon-export-arrow";
import { IconExportDownload } from "../../assets/icons/icon-export-download";
import { IconEditHovered } from "../../assets/icons/icon-edit-hover";
import { IconEdit } from "../../assets/icons/icon-edit";
import { IconDelete } from "../../assets/icons/icon-delete";
import { IconDeleteHovered } from "../../assets/icons/icon-delete-hovered";

import { IconReactive } from "../../assets/icons/icon-reactive";
import { CustomPagination } from "../common/custom-pagination/custom-pagination";
import { DisableIconEdit } from "../../assets/icons/disable-icon-edit";
import { DisableIconEditHovered } from "../../assets/icons/disable-icon-edit-hover";
import { getRecruiterLists } from "../../reducer/slices/recruiter/get-recruiter-slice";
import NoRecord from "../common/no-record/no-record";
import PatientsNoRecord from "../../assets/icons/patients-no-record";
import AddRecruierSidebar from "./add-recruier-sidebar";
import EditRecruierSidebar from "./edit-recruiters-sidebar";
import useMediaQuery from "../common/custom-hooks/use-media-query";
import { trimWithEllipsis } from "../patients/constants";
import AllowedAccess, { hasAccess } from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const RecruiterList = () => {
  const [showClose, setShowClose] = useState(false);
  const isBigDesktop = useMediaQuery("(min-width: 1537px)");
  const [mainRecruiterList, getMainRecruiterList] = useState([]);
  const [search, setSearch] = useState("");
  const [toasts, setToasts] = useState([]);
  const [recruiterList, getRecruiterList] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRefExport = useRef({});
  const [isLoading, setIsLoading] = useState(true);
  const [openRecruierSidebar, setOpenRecruierSidebar] = useState(false);
  const [currnetRecruiterId, setCurrnetRecruiterId] = useState(null);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const onSearchClick = () => {
    if (!search) {
      return;
    }
    const lowerCaseSearchTerm = search.toLowerCase();

    const searchedValue = mainRecruiterList.filter((item) => {
      return (
        item.firstName.toLowerCase().includes(lowerCaseSearchTerm) ||
        item.lastName.toLowerCase().includes(lowerCaseSearchTerm) ||
        item.recruiterEmail.toLowerCase().includes(lowerCaseSearchTerm)
      );
    });

    getRecruiterList(searchedValue);
    setShowClose(true);
  };

  const onCloseClick = () => {
    getRecruiterList([...mainRecruiterList]);
    setSearch("");
    setShowClose(false);
  };
  const clinicData = useSelector((state) => state.clinic_info.data);
  useEffect(() => {
    dispatch(getClinicInformation({}));
  }, []);

  const [cliMapping, setCliMapping] = useState({});
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = async (sortType, data) => {
    setSortOrder(sortType);
    if (sortType === "asc") {
      const oldest =
        data && data.length
          ? [...data].sort((a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              return dateA - dateB;
            })
          : [...transformedData].sort((a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              return dateA - dateB;
            });
      getRecruiterList(oldest);
    } else if (sortType === "desc") {
      const newest =
        data && data.length
          ? [...data].sort((a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              return dateB - dateA;
            })
          : [...transformedData].sort((a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              return dateB - dateA;
            });
      getRecruiterList(newest);
    }
  };

  const fetchData = async (
    apiEndpoint = ENDPOINTS.RECRUITERS.GET_RECTRUITERS
  ) => {
    setIsLoading(true);
    await axios
      .get(apiEndpoint, {
        headers: {
          "Content-Type": "application/json-patch+json",
          Accept: "text/plain",
        },
      })
      .then((res) => {
        const response = res.data.data.items;

        // Extract all unique CLI IDs from REC data
        const cliIds = [
          ...new Set(clinicData.map((rec) => rec.clinicalInfoID)),
        ];

        // Fetch CLI names for all IDs
        const cliResponse = clinicData.filter((cli) =>
          cliIds.includes(cli.clinicalInfoID)
        );

        // Convert CLI response into a mapping object
        const cliMapping = cliResponse.reduce((acc, cli) => {
          acc[cli.clinicalInfoID] = cli.name;
          return acc;
        }, {});

        handleSort(sortOrder, response);
        getMainRecruiterList(response);
        setCliMapping(cliMapping);
      });
    setIsLoading(false);
  };

  // Transform data: Replace CLIENT ID with CLIENT Name
  const transformedData = recruiterList.map((row) => ({
    ...row,
    cliName: cliMapping[row.clinicalInfoID] || "Unknown", // Replace CLI ID with CLI Name
  }));

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefExport.current &&
        !dropdownRefExport.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside2);
    return () => {
      document.removeEventListener("click", handleClickOutside2);
    };
  }, [isDropdownVisible]);

  useEffect(() => {
    handleSort(sortOrder);
  }, []);

  const handleToggleDropdown = () => {
    setDropdownVisible((prevState) => !prevState);
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const recruiterListColumn = [
    {
      name: "Recruiter Name",
      selector: (row) => (
        <div className="flex items-center">
          <p>
            <span className="recruiter-intials">
              {row.firstName?.charAt(0).toUpperCase()}
              {row.lastName?.charAt(0).toUpperCase()}
            </span>
          </p>
          {/* <p className="pl-1">
                        <span className="block">{row.firstName} {row.lastName}</span>
                         <span className="block text-[12px] text-[#777575]">{row.recruiterEmail}</span> 
                    </p> */}

          <p className="pl-1 whitespace-nowrap overflow-hidden text-ellipsis">
            <button
              onClick={() => handleEdit(row.id, row)}
              className="block font-mont text-[14px] hover:font-semibold whitespace-nowrap overflow-hidden text-ellipsis text-blue-500 hover:text-blue-700 hover:underline p-2"
            >
              {row.firstName} {row.lastName}
            </button>
          </p>
        </div>
      ),
      width: "300px",
    },
    {
      name: "Trials",
      selector: (row) => (
        <div className="flex gap-2 flex-col">
          {row.trialNames &&
            row.trialNames.split(",").map((val, index) => (
              <div
                key={index}
                className="p-2 w-fit inline-block pr-[10px] text-[#15B392] border-[#15B392] border-[1px] rounded-full font-mont font-[500] text-[14px] "
              >
                {isBigDesktop ? val : trimWithEllipsis(val)}
              </div>
            ))}
        </div>
      ),
      width: "250px",
    },
    {
      name: "Location Info",
      selector: (row) => row.clinicalRecruiterData,
    },
    {
      name: "Status",
      selector: (row) => (
        <span
          className={`${
            row.isActive ? "status-active" : "status-inactive"
          } font-mont font-[500] text-[14px] !p-2 !px-4`}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
      width: "145px",
    },
    {
      name: " ",
      selector: (row) => (
        <div className="flex flex-row item-center text-right justify-end w-[100px] overflow-visible h-[30px]">
          <div className="w-full flex text-right">
            <label className="block w-[40px] h-[24px] p-1">
              <div
                className={`relative inline-flex items-center h-[22px] w-[45px] rounded-full cursor-pointer border border-[#A6A6A6] !overflow-visible 
      ${row.recStatus ? "bg-blue-500 border-blue-500" : "bg-[#ffffff]"} `}
                onClick={() =>
                  row.recStatus
                    ? handleDelete(row.id, row)
                    : handleReactive(row.id, row)
                }
              >
                <span
                  className={`inline-block h-[14px] w-[14px] bg-[#A6A6A6] rounded-full transform transition-transform
        ${row.recStatus ? "translate-x-6 bg-white" : "translate-x-1"} `}
                ></span>
              </div>
            </label>
          </div>
        </div>
      ),
      width: "145px",
    },
  ];

  const recruiterListColumnData = transformedData?.map((rl) => {
    const rmn = rl.clinicalRecruiterData.map(
      (clinicName) => clinicName.clinicalInfoName
    );
    return {
      id: rl.recruiterID,
      cliName: rl.cliName,
      firstName: rl.firstName,
      lastName: rl.lastName,
      recruiterEmail: rl.recruiterEmail,
      clinicalRecruiterData: rmn.join(", "),
      clinicalInfo: rl.clinicalInfo,
      trialNames: rl.trialNames,
      isActive: (
        <span className={rl.isActive ? "status-active" : "status-inactive"}>
          {rl.isActive ? "Active" : "Inactive"}
        </span>
      ),
      recStatus: rl.isActive,
    };
  });

  //let navigate = useNavigate()

  const handleEdit = (id) => {
    if (hasAccess(user, [PermissionList.admin_recruiter.edit_recruiter])) {
      setCurrnetRecruiterId(id);
      setOpenRecruierSidebar(true);
      //navigate("/edit-recruiter", { state: { id } });
    }
  };

  const handleAdd = () => {
    setCurrnetRecruiterId(null);
    setOpenRecruierSidebar(true);
  };

  const closeRecruierSidebar = () => {
    setCurrnetRecruiterId(null);
    setOpenRecruierSidebar(false);
  };

  const [isReactiveOpen, setisReactiveOpen] = useState(false);
  const [idToReactive, setIdToReactive] = useState(null);
  const [rowDataReactive, setRowDataReactive] = useState(null);
  const [reactiveMsg, setreactiveMsg] = useState(false);

  const handleReactive = async (id, row) => {
    setIdToReactive(id); // Store the ID of the recruiter to delete
    setisReactiveOpen(true); // Open the popup
    setRowDataReactive(row);
    setreactiveMsg(row.recStatus);
  };

  const reactiveRecruiter = async () => {
    try {
      if (idToReactive) {
        await axios.put(
          `${ENDPOINTS.RECRUITERS.REACTIVE}?recruiterID=${idToReactive}`,
          {}
        );
        const data = [...recruiterList];
        //getRecruiterList([...data]); // Update state after deletion

        // Update state by modifying the recruiter’s status in the list
        getRecruiterList((prevList) =>
          prevList.map((recruiter) =>
            recruiter.recruiterID === idToReactive
              ? { ...recruiter, isActive: true }
              : recruiter
          )
        );

        setisReactiveOpen(false); // Close the popup
        dispatch(getRecruiterLists({}));
        addToast("Recruiter has been successfully Active.", "success");
        //fetchData();
      }
    } catch (error) {
      addToast("Error deleting Recruiter", "error");
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const closePopup = () => {
    setIsOpen(false);
    setisReactiveOpen(false);
  };
  const [idToDelete, setIdToDelete] = useState(null);
  const [rowDataDelete, setRowDataDelete] = useState(null);
  const [deleteMsg, setDeleteMsg] = useState(false);

  const handleDelete = async (id, row) => {
    setIdToDelete(id); // Store the ID of the recruiter to delete
    setIsOpen(true); // Open the popup
    setRowDataDelete(row);
    setDeleteMsg(row.recStatus);
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000); // Auto-dismiss after 3 seconds
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const deleteRecruiter = async () => {
    try {
      if (idToDelete) {
        await axios.delete(
          `${ENDPOINTS.RECRUITERS.DELETE_RECRUITERS}?recruiterID=${idToDelete}`
        );
        const data = [...recruiterList];
        getRecruiterList(data.filter((item) => item.id !== idToDelete)); // Update state after deletion

        setIsOpen(false); // Close the popup
        setIdToDelete(null);
        dispatch(getRecruiterLists({}));
        addToast("Recruiter has been successfully Inactive.", "success");
        fetchData();
      }
    } catch (error) {
      addToast("Error deleting Recruiter", "error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const rlColumn = [
    {
      name: "First Name",
      selector: (row) => row.firstName,
    },
    {
      name: "Last Name",
      selector: (row) => row.lastName,
    },
    {
      name: "Clinic Info",
      selector: (row) => row.cliName,
    },
    {
      name: "Status",
      selector: (row) => row.isActive,
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPageData, setCurrentPageData] = useState(
    recruiterListColumnData.slice(
      currentPage * rowsPerPage,
      (currentPage + 1) * rowsPerPage
    )
  );

  useEffect(() => {
    const indexOfLastItem = (currentPage + 1) * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    setCurrentPageData(recruiterList.slice(indexOfFirstItem, indexOfLastItem));
  }, [currentPage, rowsPerPage, recruiterList]); // Ensure re-computation on change

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePerPageChange = (perPage) => {
    setCurrentPage(0);
    setRowsPerPage(perPage);
  };

  return (
    <div>
      <Header
        headertitle="Recruiters"
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      <div
        className="main-body sub_header px-8 py-4 border-b"
        style={{ borderColor: "#C8D6E6" }}
      >
        <div className="flex justify-between">
          <div className="flex">
            <AllowedAccess
              permissions={[PermissionList.admin_recruiter.add_recruiter]}
            >
              <button
                onClick={() => {
                  handleAdd();
                }}
                className="btn-primary primary_btn mr-[20px]"
              >
                <svg
                  class="h-5 w-5 mr-2 text-white-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {" "}
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />{" "}
                  <circle cx="8.5" cy="7" r="4" />{" "}
                  <line x1="20" y1="8" x2="20" y2="14" />{" "}
                  <line x1="23" y1="11" x2="17" y2="11" />
                </svg>
                Add Recruiter
              </button>
            </AllowedAccess>

            <div className="flex justify-between pl-5">
              <div className="flex justify-between items-center w-full relative title_color">
                <div className="m-auto">Sort by:</div>
                <select
                  onChange={(e) => handleSort(e.target.value)}
                  value={sortOrder}
                  className="focus:outline-none font-[500] appearance-none pl-[10px] pr-[20px]"
                >
                  <option
                    value="desc"
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer text-gray-700"
                  >
                    Newest
                  </option>
                  <option
                    value="asc"
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer text-gray-700"
                  >
                    Oldest
                  </option>
                </select>
                <span className="transform -translate-y-1/2 pointer-events-none absolute mt-6 right-[-10px]">
                  <IconSortyBy />
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-5">
            <CustomPagination
              rowsPerPage={rowsPerPage}
              rowCount={recruiterListColumnData.length}
              onChangePage={handlePageChange}
              currentPage={currentPage}
              handlePerPageChange={handlePerPageChange}
            />
            <AllowedAccess
              permissions={[PermissionList.admin_recruiter.export_recruiter]}
            >
              <div className="relative" ref={dropdownRefExport}>
                {/* Export button */}
                <button
                  onClick={handleToggleDropdown}
                  className="btn-primary black_color_btn focus:outline-none"
                >
                  <IconExportDownload />
                  <span className="pl-[10px]">Export</span>
                  <span className="ml-2 text-xs text-gray-500">
                    <IconExportArrow />
                  </span>
                </button>
                {/* Dropdown with buttons */}
                {isDropdownVisible && (
                  <div
                    className="p-dd flex flex-col text-left border-solid border bg-white border-[#D1D7DC] w-full rounded-lg absolute -left-5 mt-5"
                    onClick={handleToggleDropdown}
                  >
                    <PdfExport
                      name="PDF"
                      icon={true}
                      class="bg-red"
                      tableData={currentPageData}
                      columns={rlColumn}
                      fileName="recruiter-list-export"
                      classes={
                        "py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left"
                      }
                    />
                    <ExcelExport
                      name="EXCEL"
                      data={currentPageData}
                      fileName="recruiter-list-export"
                      containerClass={"py-[1px]"}
                      classes={
                        "py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left  w-full"
                      }
                    />
                  </div>
                )}
              </div>
            </AllowedAccess>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div class="spinnerwrapper">
          <div class="spinner"></div>
        </div>
      ) : recruiterListColumnData && recruiterListColumnData.length ? (
        <AllowedAccess
          permissions={[PermissionList.admin_recruiter.view_recruiter]}
        >
          <div className="main-body">
            <div
              className={`mt-5 px-8 pb-8 pt-4 ${
                openRecruierSidebar ? "w-[calc(100vw-630px)]" : "flex-1"
              } `}
            >
              <div className="h-[calc(100vh-250px)] tbl-patient-grid">
                <DataTable
                  fixedHeader
                  fixedHeaderScrollHeight="calc(100vh - 250px)"
                  columns={recruiterListColumn}
                  data={recruiterListColumnData.slice(
                    currentPage * rowsPerPage,
                    (currentPage + 1) * rowsPerPage
                  )}
                  customStyles={customStyles}
                />
              </div>
            </div>

            {openRecruierSidebar && (
              <>
                <div
                  className={`transition-all block fixed top-[162px] right-0 h-full border-l border-[#B2ACC9] bg-[#F5F5F5] z-10 ${
                    openRecruierSidebar ? "block" : "hidden"
                  }`}
                >
                  {openRecruierSidebar && (
                    <>
                      {currnetRecruiterId ? (
                        <EditRecruierSidebar
                          key={currnetRecruiterId}
                          addToast={addToast}
                          id={currnetRecruiterId}
                          closeRecruierSidebar={closeRecruierSidebar}
                        />
                      ) : (
                        <AddRecruierSidebar
                          addToast={addToast}
                          closeRecruierSidebar={closeRecruierSidebar}
                        />
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </AllowedAccess>
      ) : (
        <NoRecord
          classes={"pt-7 px-7"}
          svg={PatientsNoRecord}
          message={"No recruiter records available at the moment."}
        />
      )}

      {/* Popup on Deletion */}
      {isOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          {deleteMsg ? (
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
              <div>
                <div>
                  <div className="flex flex-row mt-2 text-sm items-center">
                    <span className="delete-popup-bg item-center w-[50px!important]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M24.5827 13.0026C24.5827 12.5884 24.2469 12.2526 23.8327 12.2526C23.4185 12.2526 23.0827 12.5884 23.0827 13.0026H24.5827ZM19.5004 4.33594L19.0499 4.93556V4.93556L19.5004 4.33594ZM21.666 6.50155L21.0664 6.95205L21.0975 6.99343L21.1339 7.03014L21.666 6.50155ZM23.2148 1.08259C23.2129 0.668382 22.8756 0.334097 22.4614 0.335945C22.0472 0.337793 21.7129 0.675074 21.7148 1.08928L23.2148 1.08259ZM22.4744 3.23713L23.2244 3.23378V3.23378L22.4744 3.23713ZM18.4877 7.22379L18.4843 7.97379L18.4877 7.22379ZM16.3398 6.4642C15.9256 6.46236 15.5884 6.79664 15.5865 7.21085C15.5847 7.62506 15.9189 7.96234 16.3332 7.96419L16.3398 6.4642ZM22.0318 6.39716L22.6249 6.85618V6.85618L22.0318 6.39716ZM21.6477 6.7812L22.1067 7.37433L22.1067 7.37433L21.6477 6.7812ZM23.0827 13.0026C23.0827 18.5715 18.5682 23.0859 12.9993 23.0859V24.5859C19.3966 24.5859 24.5827 19.3999 24.5827 13.0026H23.0827ZM12.9993 23.0859C7.43048 23.0859 2.91602 18.5715 2.91602 13.0026H1.41602C1.41602 19.3999 6.60205 24.5859 12.9993 24.5859V23.0859ZM2.91602 13.0026C2.91602 7.43373 7.43048 2.91927 12.9993 2.91927V1.41927C6.60205 1.41927 1.41602 6.60531 1.41602 13.0026H2.91602ZM12.9993 2.91927C15.2706 2.91927 17.3646 3.66932 19.0499 4.93556L19.9509 3.73632C18.0147 2.28161 15.6066 1.41927 12.9993 1.41927V2.91927ZM19.0499 4.93556C19.8133 5.50915 20.4928 6.18861 21.0664 6.95205L22.2656 6.05104C21.6072 5.17464 20.8273 4.39477 19.9509 3.73632L19.0499 4.93556ZM21.7148 1.08928L21.7244 3.24047L23.2244 3.23378L23.2148 1.08259L21.7148 1.08928ZM18.491 6.4738L16.3398 6.4642L16.3332 7.96419L18.4843 7.97379L18.491 6.4738ZM21.7244 3.24047C21.7283 4.11587 21.7298 4.70905 21.6806 5.15902C21.6332 5.59391 21.5463 5.79905 21.4386 5.93814L22.6249 6.85618C22.9713 6.40853 23.1096 5.89143 23.1718 5.32186C23.2323 4.76739 23.2281 4.07391 23.2244 3.23378L21.7244 3.24047ZM18.4843 7.97379C19.3245 7.97753 20.018 7.98176 20.5724 7.92121C21.142 7.85901 21.6591 7.72076 22.1067 7.37433L21.1887 6.18807C21.0496 6.29571 20.8445 6.38259 20.4096 6.43008C19.9596 6.47922 19.3664 6.47771 18.491 6.4738L18.4843 7.97379ZM21.4386 5.93814C21.3942 5.99551 21.3455 6.04926 21.2929 6.09895L22.3227 7.18957C22.4318 7.08654 22.5329 6.9751 22.6249 6.85618L21.4386 5.93814ZM21.2929 6.09895C21.2597 6.13031 21.2249 6.16006 21.1887 6.18807L22.1067 7.37433C22.1818 7.31625 22.2539 7.25459 22.3227 7.18957L21.2929 6.09895ZM21.1339 7.03014L21.2757 7.17285L22.3399 6.11567L22.1981 5.97296L21.1339 7.03014Z"
                          fill="#DC3545"
                        />
                        <path
                          d="M15.3459 11.7593C15.3459 13.0545 14.2959 14.1045 13.0007 14.1045V15.6045C15.1243 15.6045 16.8459 13.883 16.8459 11.7593H15.3459ZM13.0007 14.1045C11.7054 14.1045 10.6554 13.0545 10.6554 11.7593H9.15541C9.15541 13.883 10.877 15.6045 13.0007 15.6045V14.1045ZM10.6554 11.7593C10.6554 10.4641 11.7054 9.41406 13.0007 9.41406V7.91406C10.877 7.91406 9.15541 9.63563 9.15541 11.7593H10.6554ZM13.0007 9.41406C14.2959 9.41406 15.3459 10.4641 15.3459 11.7593H16.8459C16.8459 9.63563 15.1243 7.91406 13.0007 7.91406V9.41406ZM10.6792 17.926H15.3221V16.426H10.6792V17.926ZM15.3221 22.6164H10.6792V24.1164H15.3221V22.6164ZM10.6792 22.6164C9.38398 22.6164 8.33398 21.5664 8.33398 20.2712H6.83398C6.83398 22.3949 8.55556 24.1164 10.6792 24.1164V22.6164ZM17.6673 20.2712C17.6673 21.5664 16.6173 22.6164 15.3221 22.6164V24.1164C17.4457 24.1164 19.1673 22.3949 19.1673 20.2712H17.6673ZM15.3221 17.926C16.6173 17.926 17.6673 18.976 17.6673 20.2712H19.1673C19.1673 18.1475 17.4457 16.426 15.3221 16.426V17.926ZM10.6792 16.426C8.55556 16.426 6.83398 18.1475 6.83398 20.2712H8.33398C8.33398 18.976 9.38398 17.926 10.6792 17.926V16.426Z"
                          fill="#DC3545"
                        />
                      </svg>
                    </span>
                    <span>
                      Are you sure want to Inactive{" "}
                      <b>
                        {rowDataDelete.firstName} {rowDataDelete.lastName}
                      </b>
                      ?
                    </span>
                  </div>
                </div>

                <div className="flex flex-row justify-end gap-5 mt-5">
                  <button
                    className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 red_btn"
                    onClick={deleteRecruiter}
                  >
                    Inactive
                  </button>
                  <SecondaryButton onClick={closePopup} label="Cancel" />
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
              <div>
                <div>
                  <div className="flex flex-row mt-2 text-sm items-center">
                    <span>
                      <b>
                        {rowDataDelete.firstName} {rowDataDelete.lastName}
                      </b>{" "}
                      is already inactive.
                    </span>
                  </div>
                </div>

                <div className="flex flex-row justify-end gap-5 mt-5">
                  <SecondaryButton onClick={closePopup} label="Cancel" />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {/* Popup on Deletion */}
      {isReactiveOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
            <div>
              <div>
                <div className="flex flex-row mt-2 text-sm items-center">
                  <span className="reactive-popup-bg item-center w-[50px!important]">
                    <IconReactive />
                  </span>
                  <span>
                    Are you sure want to Active{" "}
                    <b>
                      {rowDataReactive.firstName} {rowDataReactive.lastName}
                    </b>
                    ?
                  </span>
                </div>
              </div>

              <div className="flex flex-row justify-end gap-5 mt-5">
                <button
                  className="px-5 py-1 text-base rounded-md border green_btn transition-all duration-500"
                  onClick={reactiveRecruiter}
                >
                  Active
                </button>
                <SecondaryButton onClick={closePopup} label="Cancel" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecruiterList;
